// EditOrder.tsx
import React, { useState, useEffect } from "react";
import { Modal, TextInput, Select, Button, Group } from "@mantine/core";
import { RowDataOrder } from "../OrderPage/types";
import classes from "./Order.module.css";

interface EditOrderProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveChanges: (editedOrderr: RowDataOrder) => void;
  initialData: RowDataOrder | null; // Allow initialData to be null
}

const EditOrder: React.FC<EditOrderProps> = ({
  isOpen,
  onClose,
  onSaveChanges,
  initialData,
}) => {
  const [editedOrder, setEditedOrder] = useState<RowDataOrder>({
    uid: "",
    order_id: "",
    p_transaction_id: "",
    tracking_number: "",
    courier_service: "",
    merch_name: "",
    action: "",
  });

  useEffect(() => {
    // Set initialData only if it's a valid object, otherwise keep the default state
    if (initialData) {
      setEditedOrder(initialData);
    }
  }, [initialData]);

  const handleSaveChanges = () => {
    onSaveChanges(editedOrder);
    // Reset editedOrder after saving changes
    setEditedOrder({
      uid: "",
      order_id: "",
      p_transaction_id: "",
      tracking_number: "",
      courier_service: "",
      merch_name: "",
      action: "",
    });
  };

  return (
    <Modal
      opened={isOpen}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Order{" "}
        </div>
      }
      onClose={onClose}
      size="md"
      padding="lg"
    >
      <div className={classes.editOrderForm}>
        {/* Display fields for editing */}
        <TextInput
          label="Tracking Number"
          maxLength={255}
          value={editedOrder.tracking_number}
          onChange={(e) =>
            setEditedOrder({
              ...editedOrder,
              tracking_number: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Courier Service"
          value={editedOrder.courier_service}
          onChange={(e) =>
            setEditedOrder({
              ...editedOrder,
              courier_service: e.currentTarget.value,
            })
          }
        />
        <Group className={classes.buttonBottom}>
          <Button onClick={() => onClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button
            onClick={handleSaveChanges}
            className={classes.buttonSaveChanges}
          >
            Save Changes
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default EditOrder;
